import { render } from "./UserLoginHistory.vue?vue&type=template&id=1bb69434&scoped=true"
import script from "./UserLoginHistory.vue?vue&type=script&lang=js"
export * from "./UserLoginHistory.vue?vue&type=script&lang=js"

import "./UserLoginHistory.vue?vue&type=style&index=0&id=1bb69434&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb69434"]])

export default __exports__